import { SharedClassState, State } from "source/app/services/UI/State/State";
import { EPanelId } from "source/app/services/Shared/EPanelId";
import { ESharedComponent } from "../../../../../../services/UI/State/ESharedComponent";
import { INavigationMenuState } from "../../NavigationMenu";
import { GetNavigationMenuItems } from "../../NavigationMenuItems";
import { EBadgeColor } from "./EBadgeColor/EBadgeColor";
import { INavigationMenuItemBadge } from "source/app/presentation/Shared/ActivePanel/NavigationMenu/NavigationMenuItem/NavigationMenuItemBadge/Helpers/INavigationMenuItemBadge";

export function SetNavigationMenuItemBadge(
    panelTitle: EPanelId,
    value: string | number | undefined,
    backgroundColor: EBadgeColor
) {
    let attempts = 0;
    const maxAttempts = 10;

    const intervalId = setInterval(() => {
        const navigationMenu = State.ReadClass<INavigationMenuState>(
            ESharedComponent.NavigationMenu
        );

        if (navigationMenu || attempts >= maxAttempts) {
            clearInterval(intervalId);

            if (!navigationMenu) {
                console.error("Failed to get navigationMenu after 10 attempts");
                return;
            }

            const navigationMenuItem = GetNavigationMenuItems().find(
                (item) => item.id === panelTitle
            )!;

            const updatedBadge: INavigationMenuItemBadge = {
                value: value ? value.toString() : undefined,
                backgroundColor,
            };

            navigationMenuItem.badge = updatedBadge;
			
            navigationMenu.setState({
                lastBadgeUpdateTime: new Date().getTime(),
            });
        }

        attempts++;
    }, 1000);
}

export function ClearNavigationBadge(panel: EPanelId) {
    SetNavigationMenuItemBadge(panel, undefined, EBadgeColor.green);
}
